import { render, staticRenderFns } from "./CategoriesDropdown.vue?vue&type=template&id=28f76aea&scoped=true&"
import script from "./CategoriesDropdown.vue?vue&type=script&lang=js&"
export * from "./CategoriesDropdown.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesDropdown.vue?vue&type=style&index=0&id=28f76aea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f76aea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow})
